import styled from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { StepWrapper } from 'pages/checkout/components/common/layout-styled-components';

import { CalendarMinus } from './graphics/CalendarMinus';

export const InsuranceBlockWrapper = styled(StepWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;

  flex: 1 0 750px;

  padding-top: 120px;
  padding-bottom: 32px;
`;

export const InsuranceBlockGraphic = styled(CalendarMinus).attrs({ size: 72 })``;

export const InsuranceBlockContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
`;

export const InsuranceBlockTitle = styled.h1`
  ${TYPOGRAPHY.CIRCULAR.black}

  text-align: center;

  font-size: 28px;
  line-height: 36px;

  color: #26333b;
`;

export const InsuranceBlockDescription = styled.p`
  ${TYPOGRAPHY.OPEN_SANS.base}

  text-align: center;

  font-size: 16px;
  line-height: 24px;

  color: #5b6d73;
`;
